import { Toggle } from '../overview/components/toggle'
import { useOnlyMine } from '../../components/only-mine-filter'
import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { getCampaigns } from '../../../../api'
import { AuthContext } from '../../../../auth-context'
import AddCampaign from './components/add-campaign'
import ImportCampaign from './components/import-campaign'
import CampaignTable from './components/campaign-table'

const FilterWrapper = styled.div`
  padding: 32px 16px 0;
  margin: 0 auto;
  max-width: 1600px;
  @media(max-width: 900px) {
    padding: 16px 8px 0;
  }
`

const AddCampaignWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 32px 16px;
  margin: 0 auto;
  max-width: 1600px;
  @media(max-width: 1200px) {
    flex-direction: column;
  }

  @media(max-width: 900px) {
    padding: 16px 8px;
  }
`

const Campaigns = () => {
  const [onlyMine, setOnlyMine] = useOnlyMine('campaigns')
  const { user, updateUser } = useContext(AuthContext);
  const [campaignsState, updateCampaignsState] = useState(0)
  const [campaigns, updateCampaigns] = useState(null)

  const fetchCampaigns = () => {
    updateCampaignsState(1)
    return getCampaigns(user.id).then((res) => {
      updateCampaigns(res.data.campaigns)
      updateCampaignsState(2)
    })
  }

  useEffect(() => {
    if (campaignsState === 0 && user.id) {
      fetchCampaigns()
    }
  }, [campaignsState, user.id])

  return (
    <React.Fragment>
      <FilterWrapper>
        <div style={{ marginBottom: '16px' }}>
          <Toggle label="Show only my campaigns" checked={onlyMine} onChange={() => setOnlyMine(!onlyMine)} />
        </div>
      </FilterWrapper>
      <AddCampaignWrapper>
        <AddCampaign campaignsState={campaignsState} campaigns={campaigns} />
        <ImportCampaign campaignsState={campaignsState} campaigns={campaigns} />
      </AddCampaignWrapper>
      <CampaignTable onlyMine={onlyMine} campaignsState={campaignsState} campaigns={campaigns} fetchCampaigns={fetchCampaigns} />
    </React.Fragment>
  )
}

export default Campaigns
